import * as ownershipTypes from 'constants/enums/ownershipTypes'

export default {
  [ownershipTypes.EXCLUSIVE]: 'Výlučné',
  [ownershipTypes.JOINT_SPOUSES]: 'SJM',
} as const
